import Vue from "vue";
import Router from "vue-router";
import Home from "@/pages/home/index";
import Purchase from "@/pages/purchase/index";
import BuyPlan from "@/pages/buyPlan/index";
import purchaseDetail from "@/pages/purchase/detail";
import purchaseDetailMore from "@/pages/purchase/detailMore";
import contractDetail from "@/pages/purchase/contractDetail";
import purchaseDetailAll from "@/pages/purchase/contractDetail";
import createSendOrder from "@/pages/purchase/createSendOrder";
import createSendOrderDetail from "@/pages/purchase/createSendOrderDetail";
import productCertificate from "@/pages/productCertificates/index";
import productCertificateAdd from "@/pages/productCertificates/add";
import productCertificateDetail from "@/pages/productCertificates/detail";
import productCertificateDetailMore from "@/pages/productCertificates/detailMore";
import productCertificateEdit from "@/pages/productCertificates/edit";
import followOrder from "@/pages/followOrder/index";
import followOrderDetail from "@/pages/followOrder/detail";
import followOrderDetailMore from "@/pages/followOrder/detailMore";
import followOrderDetailAll from "@/pages/followOrder/detailAll";
import report from "@/pages/report/index";
import reportDetail from "@/pages/report/detail";
import reportDetailMore from "@/pages/report/detailMore";
import reportDetailAll from "@/pages/report/detailAll";
import reportAdd from "@/pages/report/add";
import reportRowAdd from "@/pages/report/rowAdd";
import sendOrder from "@/pages/sendOrder/index";
import sendOrderDetail from "@/pages/sendOrder/detail";
import sendOrderDetailMore from "@/pages/sendOrder/detailMore";
import sendOrderDetailAll from "@/pages/sendOrder/detailAll";
import sendOrderDetailBase from "@/pages/sendOrder/detailBase";
import sendOrderEms from "@/pages/sendOrder/ems";
import sendOrderAdd from "@/pages/sendOrder/add";
import sendOrderRowAdd from "@/pages/sendOrder/rowAdd";
import editSendOrder from "@/pages/sendOrder/editSendOrder";
import warehouseGet from "@/pages/sendOrder/warehouseGet";
import procurementClearance from "@/pages/sendOrder/procurementClearance";
import buyPlanView from "@/pages/buyPlan/buyPlanView";
import buyPlanIssued from "@/pages/buyPlan/buyPlanIssued";
import createNoTest from "@/pages/sendOrder/createNoTest";
import addReason from "@/pages/qualityOrder/addReason";
import qualityOrder from "@/pages/qualityOrder/index";
import qualityOrderDetail from "@/pages/qualityOrder/detail";
import qualityOrderDetailMore from "@/pages/qualityOrder/detailMore";
import qualityOrderDetailAll from "@/pages/qualityOrder/detailAll";
import qualityOrderDetailBase from "@/pages/qualityOrder/detailBase";
import importOrder from "@/pages/importOrder/index";
import importOrderDetail from "@/pages/importOrder/detail";
import importOrderDetailMore from "@/pages/importOrder/detailMore";
import importOrderDetailAll from "@/pages/importOrder/detailAll";
import importReport from "@/pages/importOrder/importReport";
import refundOrder from "@/pages/refundOrder/index";
import refundOrderDetail from "@/pages/refundOrder/detail";
import refundOrderDetailMore from "@/pages/refundOrder/detailMore";
import refundOrderDetailAll from "@/pages/refundOrder/detailAll";
import backOrder from "@/pages/backOrder/index";
import backOrderDetail from "@/pages/backOrder/detail";
import backOrderDetailMore from "@/pages/backOrder/detailMore";
import backOrderDetailAll from "@/pages/backOrder/detailAll";
import centerOrder from "@/pages/centerOrder/index";
import activities from "@/pages/centerOrder/activities";
import activitiesSelection from "@/pages/centerOrder/activitiesSelection";
import editActivitiesSelection from "@/pages/centerOrder/editActivitiesSelection";
import editDetailActivitiesSelection from "@/pages/centerOrder/editDetailActivitiesSelection";
import selectSamplePM from "@/pages/centerOrder/selectSamplePM";
import selectSampleHK from "@/pages/centerOrder/selectSampleHK";
import activitiesSelected from "@/pages/centerOrder/activitiesSelected";
import viewActivitiesSelection from "@/pages/centerOrder/viewActivitiesSelection";
import Sort from "@/pages/sort/index";
import List from "@/pages/list/index";
import Shop from "@/pages/shop/index";
import Search from "@/pages/search/index";
import Comment from "@/pages/shop/comment";
import liveList from "@/pages/liveList/index";
import discover from "@/pages/discover/index";
import upgrade from "@/pages/upgrade/index";
import allQualityDetail from "@/pages/qualityAllOrder/detail";
import allQualityDetailAll from "@/pages/qualityAllOrder/detailAll";
import allQualityOrder from "@/pages/qualityAllOrder/index";
import noQualityOrder from "@/pages/qualityNoOrder/index";
import noQualityDetail from "@/pages/qualityNoOrder/detail";
import someQualityDetail from "@/pages/qualityOrder/detail";
import someQualityDetailAll from "@/pages/qualityOrder/detailAll";
import someQualityOrder from "@/pages/qualityOrder/index";
import qualityWrite from "@/pages/qualityOrder/qualityWrite";
import qualityAudit from "@/pages/qualityOrder/qualityAudit";
import qualityReport from "@/pages/qualityOrder/qualityReport";
import qualityProcess from "@/pages/purchase/qualityProcess";
import messageUrl from "@/pages/messageUrl/index";
import login from "@/pages/login/index";
import inDevelop from "@/pages/messageUrl/inDevelop";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/inDevelop",
      name: "inDevelop",
      component: inDevelop,
      meta: {}
    },
    {
      path: "/cleanToken"
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {}
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {}
    },
    {
      path: "/purchase",
      name: "purchase",
      component: Purchase,
      meta: {}
    },
    {
      path: "/buyPlan",
      name: "buyPlan",
      component: BuyPlan,
      meta: {}
    },
    {
      path: "/purchaseDetail",
      name: "purchaseDetail",
      component: purchaseDetail,
      meta: {}
    },
    {
      path: "/contractDetail",
      name: "contractDetail",
      component: contractDetail,
      meta: {}
    },
    {
      path: "/purchaseDetailMore",
      name: "purchaseDetailMore",
      component: purchaseDetailMore,
      meta: {}
    },
    {
      path: "/purchaseDetailAll",
      name: "purchaseDetailAll",
      component: purchaseDetailAll,
      meta: {}
    },
    {
      path: "/createSendOrder",
      name: "createSendOrder",
      component: createSendOrder,
      meta: {}
    },
    {
      path: "/createSendOrderDetail",
      name: "createSendOrderDetail",
      component: createSendOrderDetail,
      meta: {}
    },
    {
      path: "/productCertificate",
      name: "productCertificate",
      component: productCertificate,
      meta: {}
    },
    {
      path: "/productCertificateAdd",
      name: "productCertificateAdd",
      component: productCertificateAdd,
      meta: {}
    },
    {
      path: "/productCertificateDetail",
      name: "productCertificateDetail",
      component: productCertificateDetail,
      meta: {}
    },
    {
      path: "/productCertificateDetailMore",
      name: "productCertificateDetailMore",
      component: productCertificateDetailMore,
      meta: {}
    },
    {
      path: "/productCertificateEdit",
      name: "productCertificateEdit",
      component: productCertificateEdit,
      meta: {}
    },
    {
      path: "/followOrder",
      name: "followOrder",
      component: followOrder,
      meta: {}
    },
    {
      path: "/followOrderDetail",
      name: "followOrderDetail",
      component: followOrderDetail,
      meta: {}
    },
    {
      path: "/followOrderDetailMore",
      name: "followOrderDetailMore",
      component: followOrderDetailMore,
      meta: {}
    },
    {
      path: "/followOrderDetailAll",
      name: "followOrderDetailAll",
      component: followOrderDetailAll,
      meta: {}
    },
    {
      path: "/report",
      name: "report",
      component: report,
      meta: {}
    },
    {
      path: "/reportDetail",
      name: "reportDetail",
      component: reportDetail,
      meta: {}
    },
    {
      path: "/reportDetailMore",
      name: "reportDetailMore",
      component: reportDetailMore,
      meta: {}
    },
    {
      path: "/reportDetailAll",
      name: "reportDetailAll",
      component: reportDetailAll,
      meta: {}
    },
    {
      path: "/reportAdd",
      name: "reportAdd",
      component: reportAdd,
      meta: {}
    },
    {
      path: "/reportRowAdd",
      name: "reportRowAdd",
      component: reportRowAdd,
      meta: {}
    },
    {
      path: "/sendOrder",
      name: "sendOrder",
      component: sendOrder,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/sendOrderDetail",
      name: "sendOrderDetail",
      component: sendOrderDetail,
      meta: {}
    },
    {
      path: "/sendOrderDetailMore",
      name: "sendOrderDetailMore",
      component: sendOrderDetailMore,
      meta: {}
    },
    {
      path: "/sendOrderDetailAll",
      name: "sendOrderDetailAll",
      component: sendOrderDetailAll,
      meta: {}
    },
    {
      path: "/sendOrderDetailBase",
      name: "sendOrderDetailBase",
      component: sendOrderDetailBase,
      meta: {}
    },
    {
      path: "/sendOrderEms",
      name: "sendOrderEms",
      component: sendOrderEms,
      meta: {}
    },
    {
      path: "/sendOrderAdd",
      name: "sendOrderAdd",
      component: sendOrderAdd,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/sendOrderRowAdd",
      name: "sendOrderRowAdd",
      component: sendOrderRowAdd,
      meta: {}
    },
    {
      path: "/editSendOrder",
      name: "editSendOrder",
      component: editSendOrder,
      meta: {}
    },
    {
      path: "/warehouseGet",
      name: "warehouseGet",
      component: warehouseGet,
      meta: {}
    },
    {
      path: "/procurementClearance",
      name: "procurementClearance",
      component: procurementClearance,
      meta: {}
    },
    {
      path: "/buyPlanView",
      name: "buyPlanView",
      component: buyPlanView,
      meta: {}
    },
    {
      path: "/buyPlanIssued",
      name: "buyPlanIssued",
      component: buyPlanIssued,
      meta: {}
    },
    {
      path: "/createNoTest",
      name: "createNoTest",
      component: createNoTest,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/addReason",
      name: "addReason",
      component: addReason,
      meta: {}
    },
    {
      path: "/qualityOrder",
      name: "qualityOrder",
      component: qualityOrder,
      meta: {}
    },
    {
      path: "/qualityOrderDetail",
      name: "qualityOrderDetail",
      component: qualityOrderDetail,
      meta: {}
    },
    {
      path: "/qualityOrderDetailMore",
      name: "qualityOrderDetailMore",
      component: qualityOrderDetailMore,
      meta: {}
    },
    {
      path: "/qualityOrderDetailAll",
      name: "qualityOrderDetailAll",
      component: qualityOrderDetailAll,
      meta: {}
    },
    {
      path: "/qualityOrderDetailBase",
      name: "qualityOrderDetailBase",
      component: qualityOrderDetailBase,
      meta: {}
    },
    {
      path: "/importOrder",
      name: "importOrder",
      component: importOrder,
      meta: {}
    },
    {
      path: "/importOrderDetail",
      name: "importOrderDetail",
      component: importOrderDetail,
      meta: {}
    },
    {
      path: "/importOrderDetailMore",
      name: "importOrderDetailMore",
      component: importOrderDetailMore,
      meta: {}
    },
    {
      path: "/importOrderDetailAll",
      name: "importOrderDetailAll",
      component: importOrderDetailAll,
      meta: {}
    },
    {
      path: "/importReport",
      name: "importReport",
      component: importReport,
      meta: {}
    },
    {
      path: "/refundOrder",
      name: "refundOrder",
      component: refundOrder,
      meta: {}
    },
    {
      path: "/refundOrderDetail",
      name: "refundOrderDetail",
      component: refundOrderDetail,
      meta: {}
    },
    {
      path: "/refundOrderDetailMore",
      name: "refundOrderDetailMore",
      component: refundOrderDetailMore,
      meta: {}
    },
    {
      path: "/refundOrderDetailAll",
      name: "refundOrderDetailAll",
      component: refundOrderDetailAll,
      meta: {}
    },
    {
      path: "/backOrder",
      name: "backOrder",
      component: backOrder,
      meta: {}
    },
    {
      path: "/backOrderDetail",
      name: "backOrderDetail",
      component: backOrderDetail,
      meta: {}
    },
    {
      path: "/backOrderDetailMore",
      name: "backOrderDetailMore",
      component: backOrderDetailMore,
      meta: {}
    },
    {
      path: "/backOrderDetailAll",
      name: "backOrderDetailAll",
      component: backOrderDetailAll,
      meta: {}
    },
    {
      path: "/centerOrder",
      name: "centerOrder",
      component: centerOrder,
      meta: {}
    },
    {
      path: "/activities",
      name: "activities",
      component: activities,
      meta: {}
    },
    {
      path: "/activitiesSelection",
      name: "activitiesSelection",
      component: activitiesSelection,
      meta: {}
    },
    {
      path: "/editActivitiesSelection",
      name: "editActivitiesSelection",
      component: editActivitiesSelection,
      meta: {}
    },
    {
      path: "/editDetailActivitiesSelection",
      name: "editDetailActivitiesSelection",
      component: editDetailActivitiesSelection,
      meta: {}
    },
    {
      path: "/selectSamplePM",
      name: "selectSamplePM",
      component: selectSamplePM,
      meta: {}
    },
    {
      path: "/selectSampleHK",
      name: "selectSampleHK",
      component: selectSampleHK,
      meta: {}
    },
    {
      path: "/activitiesSelected",
      name: "activitiesSelected",
      component: activitiesSelected,
      meta: {}
    },
    {
      path: "/viewActivitiesSelection",
      name: "viewActivitiesSelection",
      component: viewActivitiesSelection,
      meta: {}
    },
    {
      path: "/sort",
      name: "sort",
      component: Sort,
      meta: {
        keepAlive: true,
        scrollTop: 0
      }
    },
    // {
    //   path: '/discover',
    //   name: 'discover',
    //   component: discover,
    //   meta:{
    //     keepAlive:true,
    //     scrollTop: 0,
    //   }
    // },
    // {
    //   path: '/upgrade',
    //   name: 'upgrade',
    //   component: upgrade,
    //   meta:{
    //     keepAlive:true,
    //     scrollTop: 0,
    //   }
    // },
    {
      path: "/liveList",
      name: "liveList",
      component: liveList
    },
    {
      path: "/list",
      name: "list",
      component: List,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/shop/:id",
      name: "shop",
      component: Shop
    },
    {
      path: "/comment/:id",
      name: "comment",
      component: Comment
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/search",
      name: "search",
      component: Search,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/allQualityDetail",
      name: "allQualityDetail",
      component: allQualityDetail,
      meta: {}
    },
    {
      path: "/allQualityDetailAll",
      name: "allQualityDetailAll",
      component: allQualityDetailAll,
      meta: {}
    },
    {
      path: "/allQualityOrder",
      name: "allQualityOrder",
      component: allQualityOrder,
      meta: {}
    },
    {
      path: "/noQualityOrder",
      name: "noQualityOrder",
      component: noQualityOrder,
      meta: {}
    },
    {
      path: "/noQualityDetail",
      name: "noQualityDetail",
      component: noQualityDetail,
      meta: {}
    },
    {
      path: "/someQualityDetail",
      name: "someQualityDetail",
      component: someQualityDetail,
      meta: {}
    },
    {
      path: "/someQualityOrder",
      name: "someQualityOrder",
      component: someQualityOrder,
      meta: {}
    },
    {
      path: "/someQualityDetailAll",
      name: "someQualityDetailAll",
      component: someQualityDetailAll,
      meta: {}
    },
    {
      path: "/messageUrl",
      name: "messageUrl",
      component: messageUrl,
      meta: {}
    },
    {
      path: "/qualityWrite",
      name: "qualityWrite",
      component: qualityWrite,
      meta: {}
    },
    {
      path: "/qualityAudit",
      name: "qualityAudit",
      component: qualityAudit,
      meta: {}
    },
    {
      path: "/qualityReport",
      name: "qualityReport",
      component: qualityReport,
      meta: {}
    },
    {
      path: "/qualityProcess",
      name: "qualityProcess",
      component: qualityProcess,
      meta: {}
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js